/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useFormik } from 'formik';
import { Box, Button, TextField, Typography } from '@mui/material';
import * as Yup from 'yup';
import { useForgotPassword } from '../../../hooks/queries/useForgotPassword';
import withBoxStyle from '../../../HOC/layout/withBoxStyle';
import LoginRegistrationHeader from '../../../components/layout/LoginRegistrationHeader';

const EnterEmailForm = withBoxStyle(
  ({ formik, disableSubmit, isPending }: any) => {
    const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
      formik;

    return (
      <Box sx={{ p: 3 }} className="d-flex flex-column flex-1">
        <form className="d-flex flex-column flex-1" onSubmit={handleSubmit}>
          <LoginRegistrationHeader />
          <Box pt={5} mb={12.25}>
            <Typography variant="h4" color="primary" mb={1.5}>
              Password reset
            </Typography>
            <Typography variant="body1">
              Enter your email and we’ll send you a code to reset your password.
            </Typography>
          </Box>
          <TextField
            name="email"
            label="Email"
            fullWidth
            type="email"
            required
            value={values?.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched?.email && Boolean(errors?.email)}
            helperText={touched?.email && errors?.email}
          />
          <Box sx={{ pt: 7.5, mt: 'auto', mb: 4.5 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              type="submit"
              disabled={!formik.isValid || disableSubmit || isPending}
            >
              Continue
            </Button>
          </Box>
        </form>
      </Box>
    );
  }
);

const ForgotPassword: React.FC = () => {
  const { sendForgotPasswordRequest, disableSubmit, isPending } =
    useForgotPassword();
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
    }),
    onSubmit: async (data: { email: string }) => {
      try {
        const { email } = data;
        sendForgotPasswordRequest(email);
      } catch (apiError) {
        console.error(apiError);
      }
    },
    validateOnMount: true,
    validateOnChange: true,
  });

  return (
    <EnterEmailForm
      formik={formik}
      disableSubmit={disableSubmit}
      isPending={isPending}
    />
  );
};

export default ForgotPassword;
